// src/components/tiptap/InternalNoteEditor.js
import React from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Placeholder from "@tiptap/extension-placeholder";
import Mention from "@tiptap/extension-mention";

import StaffMentionExtension from "./StaffMentionExtension";

export default function InternalNoteEditor({ value, onChange, users = [] }) {
  const editor = useEditor({
    extensions: [
      StarterKit,
      Placeholder.configure({
        placeholder: "Add an internal note…",
      }),
      Mention.configure({
        HTMLAttributes: {
          class:
            "bg-blue-100 text-blue-800 px-1 rounded-sm",
        },
        suggestion: StaffMentionExtension(users),
      }),
    ],
    content: value || "",
    onUpdate: ({ editor }) => {
      const json = editor.getJSON();
      if (onChange) onChange(json);
    },
  });

  React.useEffect(() => {
    if (!editor) return;

    if (!value) {
      editor.commands.setContent("");
      return;
    }

    editor.commands.setContent(value);
  }, [value, editor]);

  if (!editor) return null;

  return (
    <div className="nj-internal-note p-2">
      <EditorContent editor={editor} />
    </div>
  );
}
